var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.classy},[_vm._v(_vm._s(_vm._f("ShortDate")(_vm.expiresAt))+" "),(_vm.expired)?_c('v-chip',{staticClass:"ml-2",attrs:{"small":"","text-color":"white","color":"red"}},[_vm._v("Expired")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }